module.exports = __webpack_public_path__ + "img/title_no.736819e9.svg";